<template>
  <system-frame
    :breadcrumb="false"
    :system-no="systemNo"
    :show-left-menus="false"
  >
    <router-view slot="routerView"></router-view>
  </system-frame>
</template>
<script>
// import WdzCommonComponent from 'wdz-common-components';
// import Vue from 'vue';
// Vue.use(WdzCommonComponent);
export default {
  name: 'app',
  data() {
    return {
      systemNo: ccconstants.SYSTEM_NOS.Web_Angular_Url, //注册系统编号
    };
  },
  components: {},
  computed: {},
  created() {
    /*Cookie.set(
      "ovo_ticket",
      "3A49B7D13A9623F1A8FCF1DE140BCEF0CE807D56FD4BBC29C312C3225C8634F7A09F17BAA26B6181A88BADB2B774D419"
    );*/
  },
  methods: {},
};
</script>
<style lang="scss" type="text/scss">
@import './common/sass/common.scss';
</style>
